<script setup lang="ts">
import { AppSvgIcon } from '@libs/ui';

interface MyPositionButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<MyPositionButtonEmits>();
</script>

<template>
  <div class="my-position-button" @click="emit('click')">
    <div class="group-info">Relevant</div>
    <div class="my-position">
      <AppSvgIcon name="position" size="18" />
      <div class="text">
        {{ $t('planner.my_position') }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.my-position-button {
  .group-info {
    @include font-label-s-bold;
    color: var(--color-neutral-70);
    margin-bottom: var(--spacing-8);
  }

  .my-position {
    display: flex;
    align-items: center;
    gap: var(--spacing-16);

    padding: var(--spacing-12);
    border-radius: var(--border-radius-12);
    cursor: pointer;
    transition: all var(--transition-medium);
    @include on-hover {
      background-color: var(--color-neutral-10);
    }

    .text {
      @include font-label-m-bold;
      color: var(--color-neutral-70);
    }
  }
}
</style>
